import css from "styled-jsx/css";
import { MOBILE_QUERY_MAX_WIDTH, SMALL_MOBILE_QUERY_MAX_WIDTH, MAX_DESKTOP_CONTENT_WIDTH } from "constants/vp-sizes";

export const componentStyles = css.global`
  .footer-container {
    padding-bottom: 8px;
    width: 100vw;
    overflow: hidden;

    .footer-content-container {
      padding: 95px 64px 0 64px;
      font-size: 0.8125rem;
      display: flex;
      justify-content: center;
      position: relative;

      .footer-content {
        display: flex;
        width: ${MAX_DESKTOP_CONTENT_WIDTH + "px"};

        .all-right-reserved-container {
          flex-shrink: 0;
          margin-right: 120px;
        }

        .categories-container {
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;

          .category-container {
            flex-grow: 1;
            width: 150px;
            margin-right: 16px;
            margin-bottom: 32px;
            display: flex;
            flex-direction: column;
          }

          .security-logos-container {
            display: flex;

            .iso-logo-img-container,
            .gdpr-logo-img-container,
            .hipaa-logo-img-container,
            .soc-logo-img-container {
              margin-right: 8px;
              cursor: pointer;

              img {
                height: 40px;
              }

              &:hover {
                img {
                  opacity: 0.7;
                }
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .footer-container .footer-content-container {
      padding: 40px 40px 0 40px;

      .footer-content {
        flex-direction: column;
        padding-left: 24px;

        .all-right-reserved-container {
          width: 100%;
        }

        .categories-container {
          .category-container {
            width: 130px;
            align-items: center;
            margin-right: 12px;

            .footer-category-component {
              width: 130px;
            }
          }

          .security-logos-container {
            img {
              width: 34px !important;
              height: 34px !important;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${SMALL_MOBILE_QUERY_MAX_WIDTH}) {
    .footer-container .footer-content-container {
      padding: 40px 16px 0 16px;
    }
  }
`;
